interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) pages.push(i);
  }

  const rendered: (number | string)[] = [];
  pages.forEach((page, index) => {
    if (index > 0 && page - pages[index - 1] > 1) rendered.push(`gap-${page}`);
    rendered.push(page);
  });

  const baseBtn =
    'min-w-9 h-9 px-3 inline-flex items-center justify-center rounded-md text-sm font-label border transition-colors cursor-pointer';

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2 mt-8" aria-label="分页导航">
      <button
        type="button"
        className={`${baseBtn} border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
        onClick={() => onChange(current - 1)}
        disabled={current <= 1}
      >
        <i className="ri-arrow-left-s-line"></i>
        <span className="ml-1 hidden sm:inline">上一页</span>
      </button>

      {rendered.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            className={`${baseBtn} ${
              item === current
                ? 'bg-primary-500 border-primary-500 text-background-50 dark:text-foreground-950'
                : 'border-background-300 text-foreground-700 hover:bg-background-100'
            }`}
            onClick={() => onChange(item)}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-foreground-400">
            ...
          </span>
        ),
      )}

      <button
        type="button"
        className={`${baseBtn} border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
        onClick={() => onChange(current + 1)}
        disabled={current >= total}
      >
        <span className="mr-1 hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}